import { render } from "./ContactPersonList.vue?vue&type=template&id=51bb4fde&scoped=true"
import script from "./ContactPersonList.vue?vue&type=script&lang=js"
export * from "./ContactPersonList.vue?vue&type=script&lang=js"

import "./ContactPersonList.vue?vue&type=style&index=0&id=51bb4fde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51bb4fde"]])

export default __exports__